"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Count = exports.EmptyListItem = exports.ListItem = exports.ListContainer = exports.Container = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.Container = (0, styled_1.default)('div') `
  display: grid;
  grid-template-columns: 1fr;
  align-items: flex-start;
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    grid-template-columns: ${({ showCount }) => showCount ? '1fr 100px' : '1fr'};
  }
`;
exports.ListContainer = (0, styled_1.default)('ul') `
  display: grid;
  grid-template-columns: ${({ minItemWidth }) => `repeat(auto-fill, minmax(${minItemWidth}px, 1fr))`};
  grid-auto-rows: 1fr;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  list-style: none;
  padding: 0;
  margin: 0;
`;
exports.ListItem = (0, styled_1.default)('li') ``;
exports.EmptyListItem = (0, styled_1.default)('li') `
  border: 2px dashed ${(0, ui_theme_1.fromTheme)('color_border')};
`;
exports.Count = (0, styled_1.default)('span') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_small')};
  text-align: right;
  ${(_a) => {
    var { exceedsMax } = _a, rest = __rest(_a, ["exceedsMax"]);
    return exceedsMax ? `color: ${(0, ui_theme_1.fromTheme)('color_danger')(rest)}` : '';
}};
  position: fixed;
  bottom: 0;
  right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  z-index: 1;
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    position: static;
    bottom: unset;
    z-index: unset;
  }
`;
//# sourceMappingURL=ActionCardList.styles.js.map